<template>
<!-- Heading -->
    <div class="row">
        <div class="col-md-12 page-header text-center">
            <h1>Create custom group(s) to compare:</h1>
        </div>
    </div>
    <br />
<!-- Query Groups -->

    <div class="row">
        <div class="col-md-4" style="min-width:320px">
            <querygroup 
            index="1"
            :states="arrstates"
            :user="store.user"
            :indicator="store.indicator"
            :years="store.years"
            :chart-type="chartType"
            :default-year="store.defaultYear"
            @passGroupData="handleGroupData" 
            ref="group1"
            ></querygroup>
        </div>
        <div class="col-md-4" style="min-width:320px">
            <querygroup 
            index="2"
            :states="arrstates"
            :user="store.user"
            :indicator="store.indicator"
            :years="store.years"
            :chart-type="chartType"
            :default-year="store.defaultYear"
            ref="group2"
            ></querygroup>
        </div>
        <div class="col-md-4" style="min-width:320px">
            <querygroup 
            index="3"
            :states="arrstates"
            :user="store.user"
            :indicator="store.indicator"
            :years="store.years"
            :chart-type="chartType"
            :default-year="store.defaultYear"
            ref="group3"
            ></querygroup>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 col-md-offset-2" style="min-width:320px">
            <querygroup 
            index="4"
            :states="arrstates"
            :user="store.user"
            :indicator="store.indicator"
            :years="store.years"
            :chart-type="chartType"
            :default-year="store.defaultYear"
            ref="group4"
            ></querygroup>
        </div>
        <div class="col-md-4" style="min-width:320px">
            <querygroup 
            index="5"
            :states="arrstates"
            :user="store.user"
            :indicator="store.indicator"
            :years="store.years"
            :chart-type="chartType"
            :default-year="store.defaultYear"
            ref="group5"
            ></querygroup>
        </div>
    </div>
    <br />
    <!-- Buttons -->
    <div class="row">
        <div class="col-md-8">
            <button class="btn btn-default btn-sm" type="button" id="AddGroup" onclick="addGroup()">Add Group</button>
            <button type="button" class="btn btn-default btn-sm" data-toggle="modal" data-target="#hospModal">
              Add Hospital
            </button>
            <button class="btn btn-default btn-sm"  @click="nextPage">Draw Graph</button>
        </div>
    </div>


<!-- Modal for hospital selection-->
<div class="modal fade" id="hospModal" tabindex="-1" role="dialog" aria-labelledby="hospModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="hospModalLabel">Single Hospital Selection</h4>
      </div>
      <div class="modal-body">
        <table class="table table-default table-striped" id="hospitalsTable" name="hospitalsTable">
            <thead>
                <tr>
                    <th>CAHID</th>
                    <th>Hospital Name</th>
                    <th>City</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                    <tr v-for="(hospital, index) in arrhospitals">
                    
                        <td>{{  hospital.cahid }}</td>
                        <td>{{  hospital.name }}</td>
                        <td>{{  hospital.cahcity }}</td>
                        <td><button class="btn btn-sm btn-default" :onclick="'addHospital( \''+hospital.cahid+'\', \'' + hospital.name+'\');'">Add</button></td>
                    </tr>
            </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
</template>

<script type="module">

</script>

<script setup>
import { ref, watch, onMounted , nextTick, toRaw } from "vue"; 
import { storeToRefs } from 'pinia'
import { useVisualizationsStore } from '../../stores/vis_store'
import querygroup from './querygroup.vue'


const { fetchHospitals, fetchStates, loadPage} = useVisualizationsStore()
const { arrhospitals , arrstates, chartType, currentPage, loading, years} = storeToRefs(useVisualizationsStore())
var store = useVisualizationsStore()

fetchHospitals();
fetchStates();
const groups = [];
const group1 = ref(null); 
const group2 = ref(null); 
const group3 = ref(null); 
const group4 = ref(null); 
const group5 = ref(null); 
groups.push(group1);
groups.push(group2);
groups.push(group3);
groups.push(group4);
groups.push(group5);





var numFound = 0;


// onMounted(() => {
//     if ( store.currentPage == 'fgroups' && store.loading == false) {
//         $('#hospitalsTable').DataTable();
//         addGroup();
//     }
        
// });

watch(arrhospitals, async () => {
    var arrHospitals = toRaw(arrhospitals.value)
    if (  store.currentPage == 'fgroups' && arrHospitals !== undefined && arrHospitals.length > 0 ) {
        //window.alert(arrHospitals.length)
        nextTick(() => {
            $('#hospitalsTable').DataTable();
            addGroup();
        });

    }
  
})



const handleGroupData = () => { 
    let data = []; 
    
    groups.forEach(function(group) {
      let d = group.value.gatherData();
      if (d.group_hidden == false) {
        if (d.group_cahid != "") {
            
            const obj = {
                'index': 0,
                'group_cahid': d.group_cahid,
                'group_name': d.group_name,
                'group_numhosp': 0,
                'group_geography': 0,
                'group_geography_region': 0,
                'group_geography_state': 0,
                'group_geography_national': 0,
                'group_netpatrev': 0,
                'group_ruralclinic': 0,
                'group_longtermcare': 0,
                'group_govtowned': 0,
                'group_system': 0,
                'group_year': d.group_year,
                'group_hidden': 0,
              };
              data.push(obj);
        } else {
            data.push(d)
        }
        
      }
      
    });
  console.log(data);
  store.groups = data
};

const nextPage = () => { 
    handleGroupData();
    store.loadPage('visualization');
};






</script>
